import TrojanHeader from '@Components/HeaderApplication/TrojanHeader';
import backgroundImg from '@Images/gradient-background.jpg';
import Flex from 'antd/es/flex';
import { FC, ReactNode } from 'react';
import styles from './SheetLayout.module.css';

interface SheetDesktopLayoutProps {
  children: ReactNode;
  header: ReactNode;
}

const SheetDesktopLayout: FC<SheetDesktopLayoutProps> = ({
  children,
  header,
}) => {
  return (
    <Flex
      vertical
      style={{ backgroundImage: `url(${backgroundImg})` }}
      className={styles.layout}
    >
      <TrojanHeader>
        <Flex
          flex="1 0 500px"
          justify="space-between"
          className={styles.headerActionItemsSection}
        >
          {header}
        </Flex>
      </TrojanHeader>
      {children}
    </Flex>
  );
};

export default SheetDesktopLayout;
